import PropTypes from "prop-types";
import React from "react";
import { DATE_FORMATS } from "../../../../constants";
import ToolTip from "../../../../parts/tooltip";
import MonthDay from "./MonthDay";
import SvgIcon from "../../../../parts/SvgIcon";

const { DATE_DAY_FORMAT } = DATE_FORMATS;

function MonthWeek(
  {
    startOfWeek,
    handleSelectDate,
    selectedDates,
    scheduledSessions,
    handleRemoveMultiple,
    dragging = false,
    expanded = false,
    editCalendar = false,
    handleEditDate = () => {},
    daysInEditMode = [],
    removing = false,
  },
  { locals: { query } }
) {
  return (
    <article className={expanded ? "expanded" : ""}>
      {editCalendar ? (
        <aside>
          <div className="flex flex-col gap-3">
            <ToolTip id="duplicate" body="Duplicate Week">
              <a
                href={`/actions/refresh?modal[type]=calendar-duplicate-week&day=${startOfWeek
                  .clone()
                  .format(DATE_DAY_FORMAT)}`}
              >
                <SvgIcon src="/img/new-icons/duplicate.svg" />
              </a>
            </ToolTip>

            <ToolTip id="progression" body="Week Progression">
              <a
                href={`/actions/refresh?modal[type]=progression&day=${startOfWeek
                  .clone()
                  .format(DATE_DAY_FORMAT)}&type=calendar-week`}
              >
                <SvgIcon src="/img/new-icons/percentage-square.svg" />
              </a>
            </ToolTip>
          </div>
          <p className="s1 -rotate-90 whitespace-nowrap">
            {startOfWeek.clone().format("MMM D")} -{" "}
            {startOfWeek.clone().add(6, "days").format("MMM D")}
          </p>
          <div className="invisible" />
        </aside>
      ) : null}
      {[0, 1, 2, 3, 4, 5, 6].map((day) => {
        const date = startOfWeek.clone().add(day, "days");
        const dayString = date.clone().format(DATE_DAY_FORMAT);
        const isSelected = selectedDates.includes(dayString);

        return (
          <MonthDay
            key={dayString}
            date={date}
            handleSelectDate={handleSelectDate}
            isSelected={isSelected}
            selectedDates={selectedDates}
            scheduledSessions={scheduledSessions}
            handleRemoveMultiple={handleRemoveMultiple}
            dragging={dragging}
            expanded={expanded}
            dayString={dayString}
            editCalendar={editCalendar}
            daysInEditMode={daysInEditMode}
            handleEditDate={handleEditDate}
            removing={removing}
          />
        );
      })}
    </article>
  );
}

MonthWeek.contextTypes = { locals: PropTypes.object };

export default MonthWeek;
